export enum ReadingDirection {
    Horizontal = 0,
    Vertical = 1,
}
